import React, { useMemo } from "react";
import Footer from "@/components/molecules/Footer";
import Header from "@/components/molecules/Header";
import SucessMessage from "@/components/atoms/SucessMessage";
import i18n from "@/translate/i18n";
import { formatCurrency } from "@/utils";
import { useTransactionData } from "@/context/transactionContext";

const isValidUrl = (urlString) => {
  if (!urlString) return false;
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

function WithdrawalStatus1xbet() {
  const { transactionData } = useTransactionData();

  const validRedirectUrl = useMemo(
    () =>
      isValidUrl(transactionData?.redirect_url)
        ? transactionData.redirect_url
        : null,
    [transactionData?.redirect_url],
  );

  if (!transactionData?.id) return null;

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header title={i18n.t("confirmation.titleSucess")} />
        <SucessMessage
          is1xbet
          title={i18n.t("confirmation.congrats")}
          subtitle={i18n.t("confirmation.content")}
          handleClick={
            validRedirectUrl
              ? () => window.location.replace(validRedirectUrl)
              : null
          }
          messageTitle={`${i18n.t(
            "confirmation.requiredAmount",
          )} ${formatCurrency(
            transactionData?.merchant_request_amount,
            transactionData?.merchant_request_currency_iso,
            true,
          )}`}
          messageDescription={i18n.t("confirmation.withdrawalDescription")}
        />
        <Footer />
      </div>
    </div>
  );
}

export default WithdrawalStatus1xbet;
